package com.ustadmobile.core.util

open class ListFilterIdOption(description: String, optionId: Int) : IdOption(description, optionId)


